import { render, staticRenderFns } from "./copy4.vue?vue&type=template&id=266fa634&scoped=true"
import script from "./copy4.vue?vue&type=script&lang=js"
export * from "./copy4.vue?vue&type=script&lang=js"
import style0 from "./copy4.vue?vue&type=style&index=0&id=266fa634&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "266fa634",
  null
  
)

export default component.exports